/** Default page size for blog and category listing pages. */
export const BLOG_LISTING_PAGE_SIZE = 26

/** wwwPages templates included in blog/category listings. */
export const BLOG_LISTING_TEMPLATES = ['blog', 'evergreen', 'geo']

/** Category slugs excluded from the nav menu query. */
export const NAV_EXCLUDED_CATEGORY_SLUGS = ['company', 'unassigned']

/** Synthetic "All" entry prepended to category nav lists. */
export const ALL_CATEGORIES_NAV_ITEM = {
  slug: '',
  title: 'All',
  key: 'all',
}
